import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import Native_Users_Table from "./Facts_table";

const Native_Users_List = () => {
  return (
    <div>
      <Card>
        <CardHeader>لیست کاربران شركت</CardHeader>
        <CardBody>
          <Native_Users_Table />
        </CardBody>
      </Card>
    </div>
  );
};

export default Native_Users_List;
